import * as core from '../../../../../../../core'

import { query } from './details.query'

export const RESOURCE = {
  payload: {
    alias: 'details',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'track-score-details',
                        },
                      },
                    },
                    span: 3,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description: 'Details',
    name: 'details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
